"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectOptionHeight = exports.pictogramScaleMultiplier = exports.mediaSize = exports.listHeight = exports.imageSize = exports.defaultSpacingConfig = exports.compactListHeight = exports.cellPriorities = void 0;
var _sizing = require("./sizing");
const mediaSize = {
  dense: 24,
  normal: 32
};

// Height of the inner cell without padding
exports.mediaSize = mediaSize;
const imageSize = {
  dense: 40,
  normal: 48
};
exports.imageSize = imageSize;
const pictogramScaleMultiplier = {
  dense: 0.834,
  normal: 1
};
exports.pictogramScaleMultiplier = pictogramScaleMultiplier;
const listHeight = {
  normal: 80,
  dense: 64
};
exports.listHeight = listHeight;
const compactListHeight = {
  normal: 40,
  dense: 36
};

/** Spacing configs for Cells to be parsed in common/hooks/useCellSpacing */

/** Default spacing config */
exports.compactListHeight = compactListHeight;
const defaultSpacingConfig = {
  innerSpacing: {
    spacingHorizontal: 2,
    spacingVertical: 1,
    offsetHorizontal: 2
  },
  outerSpacing: {
    spacingHorizontal: _sizing.gutter,
    spacingVertical: 1,
    offsetHorizontal: 0
  }
};
exports.defaultSpacingConfig = defaultSpacingConfig;
const selectOptionHeight = {
  normal: 56,
  dense: 44
};
exports.selectOptionHeight = selectOptionHeight;
const cellPriorities = ['start', 'middle', 'end'];
exports.cellPriorities = cellPriorities;